import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=24b44b48&scoped=true&"
import script from "./FormInput.vue?vue&type=script&lang=ts&"
export * from "./FormInput.vue?vue&type=script&lang=ts&"
import style0 from "./FormInput.vue?vue&type=style&index=0&id=24b44b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b44b48",
  null
  
)

export default component.exports